import classNames from "classnames";
import Styles from "./Card.module.scss";
import React from "react";
import {useNavigate} from "react-router-dom"

const Card1 = ({ img, text ,onClick,to}) => {
  const navigate = useNavigate();
  const handleClick = (e) => {
    console.log(e)
    navigate(to);
  };

  

  return (
    <div className={Styles.card_1} onClick={()=>handleClick()}>
      <img src={img} alt={text} className={Styles.card_1__image} />
      <div className={Styles.card_1__overlay}>
        <span className={Styles.card_1__param}>{text.split('\n').map((line, index) => (
            <React.Fragment key={index}>
              {line}
              <br/>
            </React.Fragment>
          ))}</span>
      </div>
    </div>
  );
};

export default Card1;
